import "./flex-space-between-wrapper.scss"

interface IFlexSpaceBetweenWrapper {
    children: React.ReactNode;
}

const FlexSpaceBetweenWrapper: React.FC<IFlexSpaceBetweenWrapper> = ({children}): JSX.Element => (
    <div className="flex-space-between-wrapper">
        {children}
    </div>
);

export default FlexSpaceBetweenWrapper;
